import { render } from "./askingDialogBox.html?vue&type=template&id=9552339e&ts=true&external"
import script from "./askingDialogBox.ts?vue&type=script&lang=ts&external"
export * from "./askingDialogBox.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__